
class AjaxForm {
  constructor(form) {
    this.form = form;
    this.submitButton = this.form.querySelector('button[type="submit"]');

    this.init();
  }

  init() {
    this.bind();
  }

  bind() {
    const instance = this;
    if (this.submitButton) {
      this.submitButton.addEventListener('click', (e) => {
        e.preventDefault();
        instance.submitAjax();
      });
    }
  }

  submitAjax() {
    const instance = this;
    const form = instance.form
    const classes = form.dataset.ajaxForm.split(',');
    const successSelector = form.dataset.successSelector;
    const success = successSelector ? document.querySelector(successSelector) : form;

    const jax = new Jax(
      form.getAttribute('action'),
      form.getAttribute('method'),
      true
    );

    const button = form.querySelector('button[type="submit"]');
    if (button) {
      button.disabled = true;
      button.classList.add('_disabled');
    }

    jax.send(new FormData(form)).then((data) => {
      let errorsList = {};
      if (data.errors) {
        errorsList = data.errors;
      }
      console.log(errorsList)
      console.log(classes)

      Object.keys(classes).forEach((i) => {
        const cls = classes[i];
        if (errorsList[cls]) {
          validatorValidateForm(form, cls, errorsList[cls]);
        } else {
          validatorCleanErrors(form, cls);
        }
      });

      if (button) {
        button.disabled = false;
        button.classList.remove('_disabled');
      }

      if (data.state === 'success') {
        success.classList.add('_success');

        setTimeout(() => {
          form.reset();
          success.classList.remove('_success');
        }, 3000);
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-ajax-form]').forEach((form) => {
    new AjaxForm(form);
  })
});